import {Container, Image} from 'react-bootstrap'
import React from 'react'
import {LOGO_404} from '../../constants/pngs'

const NotFound = ({is500 = false}) => {
  const ErrorData = {
    title: is500 ? 'Ohhh no!' : 'Oops!',
    detail: 'Looks like this page does not exist',
    logo: {
      src: LOGO_404,
    },
  }

  return (
    <div>
      <Container className='mt-5'>
        <div className='font-bold font-22 text-center mt-5'>{ErrorData.detail}</div>
        <div className='w-100 my-5'>
          <Image className='object-fit-contain mt-5 mx-auto d-block' src={ErrorData.logo.src} width={360} height={360}/>
        </div>
      </Container>
    </div>
  )
}

export default NotFound